'use strict';
/*
 * Novicell master
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */
var lazySizes = lazySizes || {};
var novicell = novicell || {};
var svaneTvis = svaneTvis || {};

// Document ready
document.addEventListener('DOMContentLoaded', function () {
    lazySizes.init();
    svg4everybody(); // Fix SVG spritemap in IE/Edge
    novicell.validate.init(); // Init Validation
    novicell.inputMasking.init(); //Init input masking
    // novicell.persistentField.init(); //Init persistentField
    // novicell.cookieInfo.init();
    novicell.search.init();
    novicell.gallery.init();
    novicell.slider.init();
    svaneTvis.megamenu.init();
    svaneTvis.navigation.init();
    svaneTvis.accordion.init();
    svaneTvis.overlay.init();
    svaneTvis.map.init();
    svaneTvis.form.init();
    svaneTvis.shopselector.init();
    svaneTvis.video.init();
    svaneTvis.languagePopup.init();
});
